<div class="container-fluid">
  <div class="row justify-content-center">
    <div class="col-auto centered">
      <label class="fs-24">QuickSource Progress</label>
    </div>
  </div>
  <div class="row row-padding justify-content-center">
    @for (
      QuickSourceProgressObject of QuickSourceProgressMap
        | keyvalue: preserveMapOrder;
      track QuickSourceProgressObject
    ) {
      <div class="tracker-part-container col-md-11">
        <div class="row justify-content-center">
          <div class="col-2 d-flex flex-column">
            <div class="row justify-content-end flex-grow-1">
              <div class="col-auto d-flex flex-column">
                <div
                  class="tracker-bar flex-grow-1"
                  [ngClass]="
                    getQuickSourceProgressClass(QuickSourceProgressObject.value)
                  "
                ></div>
                <div
                  class="tracker-dot"
                  [ngClass]="
                    getQuickSourceProgressClass(QuickSourceProgressObject.value)
                  "
                ></div>
              </div>
            </div>
          </div>
          <div class="col-10">
            @if (
              QuickSourceProgressObject.value &&
              QuickSourceProgressObject.value.status
            ) {
              <label
                class="tracker-label fw-normal"
                [ngClass]="
                  getQuickSourceProgressClass(QuickSourceProgressObject.value)
                "
                (click)="goToStep(QuickSourceProgressObject.value)"
              >
                {{
                  getQuickSourceProgressText(
                    QuickSourceProgressObject.key,
                    QuickSourceProgressObject.value
                  )
                }}
              </label>
            }
            @if (!QuickSourceProgressObject.value) {
              <label
                [ngClass]="
                  getQuickSourceProgressClass(QuickSourceProgressObject.value)
                "
                class="tracker-label fw-normal"
              >
                {{
                  getQuickSourceProgressText(
                    QuickSourceProgressObject.key,
                    QuickSourceProgressObject.value
                  )
                }}
              </label>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
